export default (() => {
	let didScroll;
	let lastScrollTop = 0;
	let headerHeight;
	const delta = 5;

	function init(header) {
		headerHeight = $(header).outerHeight();

		$(window).on('scroll', () => {
			didScroll = true;
		});

		setInterval(() => {
			if (didScroll) {
				hasScrolled(header);
				didScroll = false;
			}
		}, 250);
	}

	function hasScrolled(header) {
		const st = $(window).scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) {
			return;
		}

		// Scroll Down
		if (st > lastScrollTop && st > headerHeight) {
			$(header).removeClass('is-compact').addClass('is-hidden');
		// Scroll Up
		} else if (st > headerHeight) {
			if ((st + $(window).height()) < $(document).height()) {
				$(header).removeClass('is-hidden').addClass('is-compact');
			} else {
				$(header).removeClass('is-hidden is-compact');
			}
		} else {
			$(header).removeClass('is-hidden is-compact');
		}

		lastScrollTop = st;
	}

	return {
		init
	};
})();